import { ShieldCheck, XCircle } from "lucide-react";

const DO_NOT_ASK = [
  "Participant names",
  "Participant addresses",
  "Detailed medical histories",
  "Detailed disability information",
  "Identifying incident details",
  "Unnecessary worker private information"
];

const WE_DO_ASK = [
  "Registration position (without identifiers)",
  "Whether key procedures exist and are current",
  "Whether documents are followed in practice",
  "Whether safeguarding concerns are present (yes / no)",
  "Your 30 / 60 / 90 day priority"
];

export function ExclusionsSection() {
  return (
    <section className="container py-16">
      <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <p className="eyebrow">§ 02 · Scope of Intake</p>
          <h2 className="mt-3 font-display text-3xl font-medium tracking-tight text-foreground sm:text-4xl">
            What we ask for. What we will never ask for.
          </h2>
          <p className="mt-3 text-base leading-relaxed text-muted-foreground">
            The intake is deliberately written to elicit governance and operational signal
            without ever requesting identifying or sensitive participant information.
          </p>
        </div>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="paper-card p-6 sm:p-8">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-sm bg-success-soft text-success">
              <ShieldCheck className="h-4 w-4" />
            </span>
            <h3 className="font-display text-lg font-medium text-foreground">What the intake asks for</h3>
          </div>
          <ul className="mt-5 space-y-3">
            {WE_DO_ASK.map((item) => (
              <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-foreground/85">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent" />
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="paper-card border-destructive/30 p-6 sm:p-8">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-sm bg-destructive-soft text-destructive">
              <XCircle className="h-4 w-4" />
            </span>
            <h3 className="font-display text-lg font-medium text-foreground">What the intake will not ask for</h3>
          </div>
          <ul className="mt-5 space-y-3">
            {DO_NOT_ASK.map((item) => (
              <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-foreground/85">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-destructive" />
                {item}
              </li>
            ))}
          </ul>
          <p className="mt-5 border-t border-border pt-4 text-xs leading-relaxed text-muted-foreground">
            If sensitive identifying information is detected in any free-text answer, the
            assessment is automatically routed to <span className="font-medium text-foreground">Manual Review Required</span>.
          </p>
        </div>
      </div>
    </section>
  );
}
